import { useAuthStore } from '@/store/auth';
import { useDashboardMode } from '@/store/mode';
import Wallet from './Wallet';
import BuyerWallet from './BuyerWallet';

/**
 * One route, two wallets.
 *
 * Sellers are owed money and need payouts; buyers have spent money and need
 * receipts and reassurance. Sharing a screen meant one of them always saw
 * controls that did nothing - a buyer staring at "Request payout" on a £0.00
 * balance, or a seller hunting for it among refund figures.
 *
 * Which wallet you see follows the dashboard's Buying/Selling toggle, not the
 * account's stored role - every Souqli account registers as BUYER and "seller"
 * is a display mode, so keying off role meant a seller who flipped to Selling
 * still landed on the buyer wallet. Mirrors DashboardLayout's defaulting
 * (Selling the first time, otherwise wherever you last left it).
 */
export function WalletRouter() {
  const userId = useAuthStore((s) => s.user?.id);
  const storedMode = useDashboardMode((s) => s.mode);
  const storedUserId = useDashboardMode((s) => s.userId);
  const mode = (storedMode && storedUserId === userId) ? storedMode : 'SELLER';
  return mode === 'SELLER' ? <Wallet /> : <BuyerWallet />;
}
